import { COMPANY_SIZE } from 'src/data/company';
import { getCustomerPlan, isPlanFromBusinessCategory } from 'src/data/subscription';
import { getUserCompanySize } from 'src/data/user';
import { useCurrentCustomer, useCurrentUser, useIsUserAllowedToBookDemo } from 'src/store';

const URL_SMB = 'https://meetings.hubspot.com/danny-feuer/business-demo-';
const URL_ENTERPRISE = 'https://meetings.hubspot.com/lee-messier1';

const getRegularUrlFromCompanySize = (companySize) => {
  switch (companySize) {
    case COMPANY_SIZE.size_1:
    case COMPANY_SIZE.size_2_10:
    case COMPANY_SIZE.size_11_50:
    default:
      return '';

    case COMPANY_SIZE.size_51_100:
    case COMPANY_SIZE.size_101_500:
      return URL_SMB;

    case COMPANY_SIZE.size_501_1000:
    case COMPANY_SIZE.size_1000_more:
      return URL_ENTERPRISE;
  }
};

const getBusinessUrlFromCompanySize = (companySize) => {
  switch (companySize) {
    case COMPANY_SIZE.size_1:
    case COMPANY_SIZE.size_2_10:
    case COMPANY_SIZE.size_11_50:
    case COMPANY_SIZE.size_51_100:
    case COMPANY_SIZE.size_101_500:
    default:
      return URL_SMB;

    case COMPANY_SIZE.size_501_1000:
    case COMPANY_SIZE.size_1000_more:
      return URL_ENTERPRISE;
  }
};

export const useBookDemoInfo = () => {
  const userAllowedToBookDemo = useIsUserAllowedToBookDemo();

  const currentUser = useCurrentUser();
  const companySize = getUserCompanySize(currentUser);

  const currentCustomer = useCurrentCustomer();
  const plan = getCustomerPlan(currentCustomer);
  const isBusinessPlan = isPlanFromBusinessCategory(plan);

  const bookDemoUrl = isBusinessPlan
    ? getBusinessUrlFromCompanySize(companySize)
    : getRegularUrlFromCompanySize(companySize);
  const allowedToBookDemo = bookDemoUrl && (isBusinessPlan || userAllowedToBookDemo);

  return { bookDemoUrl, allowedToBookDemo };
};
